import { type FC, StrictMode } from 'react';

import type { WebCompProps } from '@helsenorge/framework-utils/web-component/register';

import SearchPage from './components/search-page';
import Wrapper from './components/wrapper';

export interface CMSAgentProps extends WebCompProps {
  query?: string;
  searchurl?: string;
  language?: string;
  searchtype?: string;
  nohitsurl?: string;
  title?: string;
  searchresulttitle?: string;
  nohitstext?: string;
  nohitslinktitle?: string;
  inputarialabel?: string;
  containerarialabel?: string;
  submitbuttontext?: string;
  showmorebuttontext?: string;
  loadingstart?: string;
  loadinginprogress?: string;
  loadingend?: string;
  searcherrormessage?: string;
  noqueryerrormessage?: string;
  searchresultsstatusmessage?: string;
  tjenestehittypetext?: string;
  verktoyhittypetext?: string;
  gototjeneste?: string;
  gotoverktoy?: string;
  paginationmessage?: string;
  returnurltext?: string;
  betatag?: string;
  showsummary?: string;
  moreinformation?: string;
  closebutton?: string;
  showmore?: string;
  showless?: string;
  loadingsummaryunderstanding?: string;
  loadingsummaryfetching?: string;
  loadingsummaryoptimizing?: string;
  loadingsummarygenerating?: string;
  summaryexplainedtext?: string;
  moreinformationtitle?: string;
  moreinformationtext?: string;
  summarytitle?: string;
  linkstitle?: string;
  actionstitle?: string;
  missinginformationmessage?: string;
  wassummaryhelpful?: string;
  summarywashelpfularialabel?: string;
  summarywasnothelpfularialabel?: string;
  showsummarybydefault?: string;
}

const CMSAgent: FC<CMSAgentProps> = props => {
  return (
    <StrictMode>
      <Wrapper>
        <SearchPage
          query={props.query || ''}
          searchUrl={props.searchurl || '/sok/'}
          language={props.language || 'no'}
          contentReference={null}
          referrer={null}
          searchType={props.searchtype || 'internsøk - med ki'}
          noHitsUrl={props.nohitsurl || '/innholdsoversikt/'}
          isSummaryAvailable={props.enablesummary === 'true'}
          isSummaryEnabledByDefault={props.showsummarybydefault === 'true'}
          resources={{
            title: props.title || 'Søkeresultater',
            searchResultTitle: props.searchresulttitle || 'Søkeresultater for {query}',
            noHitsText: props.nohitstext || '<p>Sjekk stavingen og prøv eventuelt et annet ord.</p>',
            noHitsLinkTitle: props.nohitslinktitle || 'Innhold A til Å',
            inputAriaLabel: props.inputarialabel || 'Søk',
            containerAriaLabel: props.containerarialabel || 'Søk på helsenorge.no',
            submitButtonText: props.submitbuttontext || 'Søk',
            showMoreButtonText: props.showmorebuttontext || 'Vis flere',
            loadingstart: props.loadingstart || 'Leter etter innhold...',
            loadinginprogress: props.loadinginprogress || 'Henter innhold...',
            loadingend: props.loadingend || 'Lager resultatliste',
            searchErrorMessage: props.searcherrormessage || 'Teknisk feil',
            noQueryErrorMessage: props.noqueryerrormessage || '0 treff - Du har ikke skrevet inn et søkeord',
            searchResultsStatusMessage: props.searchresultsstatusmessage || '{totalHits} treff på «{query}»',
            tjenesteHitTypeText: props.tjenestehittypetext || 'Tjeneste',
            verktoyHitTypeText: props.verktoyhittypetext || 'Verktøy',
            goToTjeneste: props.gototjeneste || 'Gå til tjenesten',
            goToVerktoy: props.gotoverktoy || 'Gå til verktøyet',
            paginationMessage: props.paginationmessage || 'Viser {hits} av {totalHits} treff',
            returnUrlText: props.returnurltext || 'Søkeresultat',
            betaTag: props.betatag || 'Beta',
            showSummary: props.showsummary || 'Vis KI-oppsummering',
            moreInformation: props.moreinformation || 'Mer informasjon',
            closeButton: props.closebutton || 'Lukk',
            showMore: props.showmore || 'Vis mer',
            showLess: props.showless || 'Vis mindre',
            loadingSummaryUnderstanding: props.loadingsummaryunderstanding || 'Forstår spørsmålet',
            loadingSummaryFetching: props.loadingsummaryfetching || 'Henter relevant informasjon',
            loadingSummaryOptimizing: props.loadingsummaryoptimizing || 'Optimaliserer informasjon',
            loadingSummaryGenerating: props.loadingsummarygenerating || 'Lager sammendrag av tekst',
            summaryExplainedText:
              props.summaryexplainedtext ||
              'Helsenorge prøver ut en KI-oppsummering av søket ditt. Du kan slå oppsummeringen av eller på med bryteren.',
            moreInformationTitle: props.moreinformationtitle || 'Hva er oppsummering?',
            moreInformationText:
              props.moreinformationtext ||
              '[{"_type":"block","_key":"46EE6C39","markDefs":[],"style":"normal","level":null,"listItem":null,"children":[{"_type":"span","_key":"73EFBDC5","marks":[],"text":"Om beta-versjonen"}]}]',
            summaryTitle: props.summarytitle || 'Oppsummering',
            linksTitle: props.linkstitle || 'Mer å lese',
            actionsTitle: props.actionstitle || 'Mer å gjøre',
            missingInformationMessage: props.missinginformationmessage || 'Vi har ikke nok informasjon til å lage en oppsummering for deg',
            wasSummaryHelpful: props.wassummaryhelpful || 'Var oppsummeringen nyttig?',
            summaryWasHelpfulAriaLabel: props.summarywashelpfularialabel || 'Ja, oppsummeringen var nyttig',
            summaryWasNotHelpfulAriaLabel: props.summarywasnothelpfularialabel || 'Nei, oppsummeringen var ikke nyttig',
          }}
        />
      </Wrapper>
    </StrictMode>
  );
};

export default CMSAgent;
